import { Badge } from "@mantine/core";

import {
  getCoverageStatusBadgeProps,
  getCoverageStatusLabel,
} from "@/billing/utils/coverage-status-display";

export type CoverageStatusBadgeVariant = "active" | "not-eligible" | "unknown";

export { getCoverageStatusBadgeProps, getCoverageStatusLabel };

export interface CoverageStatusBadgeProps {
  value: string | undefined;
}

export function CoverageStatusBadge({ value }: CoverageStatusBadgeProps) {
  const { color, label } = getCoverageStatusBadgeProps(value);
  return (
    <Badge size="sm" radius="xs" color={color} variant="dot" bd={`1px solid ${color}`}>
      {label}
    </Badge>
  );
}
